import React, { useEffect,useState, useMemo } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetOccupancyForecastData } from '../../../api/services/pms';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import PropTypes from 'prop-types'
import { GetHotels } from '../../../api/services/organization'
import { onError } from '../../shared/messages'
import { dateFormat, dateFormatShort } from '../../shared/constants'
import { createExcelHeader } from '../../GridPanel/utility'

const GuestsForecastReport = ({ HotelID }) => {
    const text = useTextResources()
    const [searchState, setSearchState] = useState({})
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const days = 10

    useEffect(()=>{
        (async ()=>{
            try {
                const hotels = await GetHotels()
                setHotels(hotels)
            } catch (error) {
                onError(error)
            }
        })()
    }, [HotelID])

    const onSearchChange = (search) => {
        if (!search.StartDate) {
            search.StartDate = moment().startOf("day").toDate();
        }
        setSearchState(search)
    }

    const onSearchComplete = (data, searchState) => {
        setSearchState(searchState)
        const groups = {
            "TotalLocalGuests": "Local",
            "AdultsLocal" : "Local",
            "ChildrenLocal": "Local",
            "InfantsLocal": "Local",
            "TotalTouristsGuests": "Tourist",
            "AdultsTourist": "Tourist",
            "ChildrenTourist": "Tourist",
            "InfantsTourist": "Tourist",
            "TotalGuests": "TotalGuests",
            "TotalInfants": "TotalInfants",
            "Arrivals":"Arrivals",
            "Departures":"Departures",
            "StaysOver":"StaysOver",
            "Occupied":"Occupied",
        }
        const rows = ["TotalLocalGuests", "AdultsLocal", "ChildrenLocal", "InfantsLocal", "TotalTouristsGuests", "AdultsTourist", "ChildrenTourist", "InfantsTourist", "TotalGuests", "TotalInfants", "Arrivals", "Departures", "StaysOver", "Occupied"]
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        let newData = rows.map(row => {
            let newRow = {
                "Description": text(row),
                "ID": row,
                "Group": groups[row]
            }
            for (let date of range.by("day")) {
                const getReservationDailyAccommodations = (_reservation) => _reservation.ReservationDailyAccommodations.find(obj => moment(obj.Date).isSame(date.clone(), "day"));
                let departureReservations = data.reservations.filter(obj => moment(obj.CheckOutDate).isSame(date.clone(), "day"));
                let arivalReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSame(date.clone(), "day"));
                let rangeOfOccuipedReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSameOrBefore(date, 'day') && moment(obj.CheckOutDate).isAfter(date, 'day'))
                let localRoomNight = rangeOfOccuipedReservations.filter(r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country.Id).length
                let touristRoomNight = rangeOfOccuipedReservations.filter(r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country.Id).length
                let occuiped = localRoomNight + touristRoomNight
                let rangeReservations = data.reservations.filter(obj => date.isBetween(moment(obj.CheckInDate).startOf("day"), moment(obj.CheckOutDate).startOf("day"), undefined, '[)'))
                let rangeReservationsForGuests = data.reservations.filter(obj => date.isBetween(moment(obj.CheckInDate).startOf("day"), moment(obj.CheckOutDate).startOf("day"), undefined, '[]'))
                let localReservations = rangeReservationsForGuests.filter(r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country.Id)
                let touristReservations = rangeReservationsForGuests.filter(r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country.Id)
                let totalGuests =
                    data.reservations.reduce((initialValue, reservation) => {
                        const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                        if (reservationDailyAccommodations) {
                            return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                        }
                        else {
                            return localReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0)
                        }
                    }, 0)

                let touristInfants =
                    touristReservations.reduce((initialValue, reservation) => {
                        const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                        if (reservationDailyAccommodations) {
                            return initialValue + reservationDailyAccommodations.Infants
                        }
                        else {
                            return localReservations.reduce((initialValue, item) => initialValue + item.Infants, 0);
                        }
                    }, 0)
                let localInfants =
                    localReservations.reduce((initialValue, reservation) => {
                        const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                        if (reservationDailyAccommodations) {
                            return initialValue + reservationDailyAccommodations.Infants
                        }
                        else {
                            return localReservations.reduce((initialValue, item) => initialValue + item.Infants, 0);
                        }
                    }, 0)
                let totalInfants = touristInfants + localInfants
                let stayOverReesrvations = rangeReservations.filter(obj => !(moment(obj.CheckOutDate).isSame(date.clone(), "day") || moment(obj.CheckInDate).isSame(date.clone(), "day")))
                switch (row) {
                    case 'TotalLocalGuests':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'AdultsLocal':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Adults, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'ChildrenLocal':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Children
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Children, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'InfantsLocal':
                        newRow[date.format(dateFormat)] = localInfants
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'TotalTouristsGuests':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'AdultsTourist':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Adults, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'ChildrenTourist':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Children
                                }
                                else {
                                    return localReservations.reduce((initialValue, item) => initialValue + item.Children, 0);
                                }
                            }, 0)
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'InfantsTourist':
                        newRow[date.format(dateFormat)] = touristInfants
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'TotalGuests':
                        newRow[date.format(dateFormat)] = totalGuests
                        newRow["ParentId"] = null
                        break;
                    case 'TotalInfants':
                        newRow[date.format(dateFormat)] = totalInfants
                        newRow["ParentId"] = null
                        break;
                    case 'Arrivals':
                        newRow[date.format(dateFormat)] = arivalReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0);
                        newRow["ParentId"] = null
                        break;
                    case 'Departures':
                        newRow[date.format(dateFormat)] = departureReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0);
                        newRow["ParentId"] = null
                        break;
                    case 'StaysOver':
                        newRow[date.format(dateFormat)] =
                        stayOverReesrvations.reduce((initialValue, reservation) => {
                            const reservationDailyAccommodations = getReservationDailyAccommodations(reservation);
                            if (reservationDailyAccommodations) {
                                return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                            }
                            else {
                                return localReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0) + touristReservations.reduce((initialValue, item) => initialValue + item.Adults + item.Children + item.Infants, 0)
                            }
                        }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'Occupied':
                        newRow[date.format(dateFormat)] = occuiped
                        newRow["ParentId"] = null
                        break;
                }
            }
            return newRow

        })
        newData.forEach(row => {
            if (row.Description.startsWith('[Adults')) {
                row.Description = "Adults"
            }
            if (row.Description.startsWith('[Children')) {
                row.Description = "Children"
            }
            if (row.Description.startsWith('[Infants')) {
                row.Description = "Infants"
            }
        })
        setData(newData)
    }
    const formatter = ({ value }) => {
        return <div style={{ fontSize: '1.2rem' }}>{value}</div>
    }
    const columns = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumns = Array.from(range.by("day")).map(day => {
            return {
                name: day.format(dateFormat),
                title: day.format(dateFormatShort),
                formatter
            }
        })
        return [
            { name: 'Description', title: 'Description', formatter },
            { name: 'Group', title: 'Group' },
            ...dateColumns
        ]
    }, [searchState.StartDate])


    const columnExtensions = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumnExtensions = Array.from(range.by("day")).map(day => {
            return {
                columnName: day.format(dateFormat),
                width: 135
            }
        })
        return [
            ...dateColumnExtensions
        ]
    }, [searchState.StartDate])


    const getExcelHeaderTitle = () => {
        const hotel = hotels.find(x => x.Id === HotelID)
        return `Guests Forecast Report ${hotel && hotel.Name}, ${moment(searchState.StartDate).format(dateFormat)} - ${moment(searchState.StartDate).add(days, "days").format(dateFormat)}`;
    }

    const gridOptions = useMemo(() => {
        return {
        search: {
            title: text("GuestsForecastReport"),
            fields: [
                <Form.Field control={HotelsDropDown} clearable width="4" label={text("Hotel")} key="HotelID" />,
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="StartDate"
                    key="StartDate"
                />
            ],
            initial: {
                "StartDate": moment().startOf("day").toDate(),
                "HotelID": HotelID
            },
            api: GetOccupancyForecastData,
            spec: {
                EndDate: moment(searchState.StartDate).add(days, "days").toISOString()
            },
            groupSize: 6
        },
        grid: {
            columns: columns,
            tree: {
              getChildRows: (row, rootRows) => {
                const childRows = rootRows.filter(r => r.ParentId === (row ? row.Id : null));
                return childRows.length ? childRows : null;
              },
              treeColumnName: "Description"
            },
            summary: true,
            export: true,
            pdf: true,
            customOptions:{
                hidden:{
                    hiddenColumns: [ {columnName: 'Group'}]
                }
            },
            columnExtensions: columnExtensions,
            excel: {
                customizeHeader: createExcelHeader(getExcelHeaderTitle()),
                grouping:  [{ columnName: "Group" }],
                totalSummaryItems: [
                    { columnName: "Group", type: 'sum' }
                ],
            },
        }
    }
}, [data])

return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} onSearchChange={onSearchChange} data={data} />)
}

GuestsForecastReport.propTypes = {
    HotelID: PropTypes.any
}
export default GuestsForecastReport
